import styles from './Headline.module.css';

export interface HeadlineProps {
  first: string;
  second: string;
  size?: 'page' | 'compact' | 'onboarding' | 'hero';
}

export function Headline({ first, second, size = 'page' }: HeadlineProps) {
  return (
    <h1 className={styles.headline} data-size={size}>
      <span>{first}</span> <span className={styles.second}>{second}</span>
    </h1>
  );
}
